<!-- Login.vue -->
<template>
  <AppLogin />
</template>

<script setup lang="ts">
import AppLogin from '@/auth/AppLogin.vue'

definePage({
  name: 'LoginPage',
  meta: {
    doesNotRequireAuth: true
  }
})
</script>
